import { useParams } from 'react-router-dom';
import { useOrg } from '../components/OrgContext';
import { homeKindFor } from './company';

// /cases/:id (redesign step 3, piece 7c; dev website only: App.tsx calls this only when the release switch is on). A pure agent gets the new
// case page; everyone else keeps today's case page (CaseFocus), unchanged. Anything that is not a case id (a sell-side reference) stays on
// today's page too.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export default function CaseRouteEntry({ page, legacy }) {
  const { capabilities } = useOrg();
  const { id } = useParams();
  return homeKindFor(capabilities) === 'agent' && UUID.test(String(id || '')) ? page : legacy;
}
